import axios from 'axios';

let url = '';
if (process.env.NODE_ENV === 'development') {
	// url = 'http://127.0.0.1:8000/api/';
	url = 'https://back.printster.in/api/';
} else {
	url = 'https://back.printster.in/api/';
}

// Create axios instance
const apiInstance = axios.create({
	baseURL: url
});

// Add request interceptor to validate URLs before sending
apiInstance.interceptors.request.use(
	(config) => {
		// Check for undefined values in the URL
		const fullUrl = config.baseURL + config.url;
		
		if (fullUrl.includes('undefined') || fullUrl.includes('null')) {
			console.error('Malformed URL detected:', fullUrl);
			console.error('Config:', config);
			
			// Reject the request with a clear error
			return Promise.reject(new Error(`Malformed URL detected: ${fullUrl}. Please check the endpoint parameters.`));
		}

		return config;
	},
	(error) => {
		console.error('Request interceptor error:', error);
		return Promise.reject(error);
	}
);

// Add response interceptor for additional error handling
apiInstance.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		// Enhanced error logging
		if (error.config) {
			console.error(`API Error: ${error.config.method?.toUpperCase()} ${error.config.baseURL}${error.config.url}`);
		}
		
		return Promise.reject(error);
	}
);

export default apiInstance;
